import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import KioskGamificationProfile from "./components/KioskGamificationProfile";
import { useTenant } from "../../hooks/useTenant";
import { Spinner } from "reactstrap";

/**
 * Página de detalhes do treino acessada via "Ver todos os treinos"
 * Recebe o membro via navigation state
 */
const WorkoutDetailsScreen = () => {
    document.title = "Detalhes do Treino | NeoApp";
    const location = useLocation();
    const navigate = useNavigate();
    const { tenantLogo, loading: tenantLoading } = useTenant();
    const member = location.state?.member;

    if (tenantLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
                <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
            </div>
        );
    }

    if (!member) {
        return (
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
                <i className="mdi mdi-account-off-outline display-3 text-muted mb-3" />
                <h5 className="fw-bold text-dark">Nenhum aluno selecionado</h5>
                <button className="btn btn-primary mt-3 rounded-pill px-4" onClick={() => navigate("/kiosk/print")}>
                    <i className="mdi mdi-arrow-left me-1" />Voltar
                </button>
            </div>
        );
    }

    return (
        <KioskGamificationProfile
            member={member}
            onBack={() => navigate("/kiosk/print")}
            printOnlyMode={true}
            tenantLogo={tenantLogo}
        />
    );
};

export default WorkoutDetailsScreen;
